var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { Fragment, useState, useCallback } from "react";
import styled from "styled-components";
import useToggle from "react-use/lib/useToggle";
import { H5 } from "../../components/typography";
import { Icon } from "../../components/icon";
import { Button } from "../../components/button";
import Flex from "../../components/templates/flex";
import Layer from "../../components/templates/layer";
import General from "./general";
import Dashboard from "./dashboard";
import SearchProvider, { SearchInput, SearchResults } from "./search";
var Container = styled(Flex).attrs({
    padding: [6],
    background: "dropdown",
    gap: 6,
    column: true,
    round: true,
    overflow: { vertical: "auto" },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n"], ["\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n"])));
var Header = function (_a) {
    var children = _a.children, onClose = _a.onClose;
    return (React.createElement(Flex, { width: "100%", alignItems: "center", justifyContent: "between", padding: [0, 0, 4], border: { side: "bottom", color: "disabled" } },
        React.createElement(Flex, { gap: 2, alignItems: "center" }, children),
        React.createElement(Button, { icon: "x", neutral: true, small: true, onClick: onClose, flavour: "borderless", "data-testid": "documentation-help-close" })));
};
var views = { general: "general", dashboard: "dashboard", search: "search" };
var titles = { general: "Need help?", dashboard: "Need help?" };
var Documentation = function (_a) {
    var _b = _a.app, app = _b === void 0 ? "cloud" : _b, onCloseClick = _a.onCloseClick, onVisitDocumentClick = _a.onVisitDocumentClick, onOpenIssueClick = _a.onOpenIssueClick, onOpenBugClick = _a.onOpenBugClick, onContributeClick = _a.onContributeClick, onSupportClick = _a.onSupportClick, children = _a.children;
    var _c = useToggle(), isOpen = _c[0], toggle = _c[1];
    var _d = useState(views.general), view = _d[0], setView = _d[1];
    var isGeneral = view === views.general;
    var setDashboardView = useCallback(function () { return setView(views.dashboard); }, []);
    var setGeneralView = useCallback(function () { return setView(views.general); }, []);
    var setSearchView = useCallback(function () { return setView(views.search); }, []);
    var closeClicked = useCallback(function () {
        toggle();
        if (onCloseClick)
            onCloseClick();
    }, []);
    return (React.createElement(Fragment, null,
        children(toggle, isOpen),
        isOpen && (React.createElement(Layer, { position: "bottom-left", backdrop: true, margin: [5, 17], onClickOutside: toggle, onEsc: toggle },
            React.createElement(SearchProvider, null, function (_a) {
                var searchTerm = _a.searchTerm, setSearchTerm = _a.setSearchTerm, results = _a.results, reset = _a.reset;
                return (React.createElement(Fragment, null,
                    React.createElement(Container, { width: {
                            max: isGeneral ? "325px" : view === views.dashboard ? "600px" : "100%",
                        }, "data-testid": "documentation-layer" },
                        React.createElement(Header, { onClose: closeClicked },
                            isGeneral && (React.createElement(Icon, { color: "text", name: "questionFilled", width: "18px", height: "18px" })),
                            !isGeneral && (React.createElement(Button, { icon: "arrow_left", neutral: true, small: true, onClick: function () {
                                    setGeneralView();
                                    reset();
                                }, flavour: "borderless", "data-testid": "dashboard-back" })),
                            React.createElement(H5, { margin: [0] }, titles[view] || titles.general)),
                        view !== views.dashboard && (React.createElement(SearchInput, { defaultValue: searchTerm, setSearchTerm: setSearchTerm, setSearchView: setSearchView })),
                        isGeneral && (React.createElement(Flex, { gap: 6, overflow: { vertical: "auto" }, column: true, padding: [1] },
                            React.createElement(General, { app: app, onDashboardClick: setDashboardView, onVisitDocumentClick: onVisitDocumentClick, onOpenIssueClick: onOpenIssueClick, onOpenBugClick: onOpenBugClick, onContributeClick: onContributeClick, onSupportClick: onSupportClick }))),
                        view === views.dashboard && React.createElement(Dashboard, null),
                        view === views.search && React.createElement(SearchResults, { results: results }))));
            })))));
};
export default Documentation;
var templateObject_1;
